import React from 'react'
import { connect } from 'react-redux'
import { connectFitness, updateFitnessSettings } from 'supporticon/api/fitness'
import { getSegmentedCustomSupporterPage } from '../../lib/segmentation'
import { getFitnessTypes } from '../../lib/fitness'
import { selectCustomSupporterPages } from '../../store/customSupporterPages'
import { selectPage, selectUser } from '../../store/session'

import Status from '../../components/container/Status'
import Theme from '../../components/utils/Theme'

class StravaConnect extends React.Component {
  constructor () {
    super()
    this.connectPageFitness = this.connectPageFitness.bind(this)
    this.handleSuccess = this.handleSuccess.bind(this)
  }

  componentDidMount () {
    const { location, user } = this.props

    if (location.query.code) {
      return connectFitness({
        code: location.query.code,
        scope: location.query.scope,
        token: user.token
      })
        .then(this.connectPageFitness)
        .then(this.handleSuccess)
    } else {
      setTimeout(this.handleSuccess, 1000)
    }
  }

  connectPageFitness () {
    const { customSupporterPages, page, user } = this.props
    const { fitness = {} } = getSegmentedCustomSupporterPage(customSupporterPages, page)
    const subscribedActivities = getFitnessTypes(fitness.types || [])
      .filter(type => type !== 'manual')

    return updateFitnessSettings({
      pageId: page.uuid,
      token: user.token,
      showPhotos: true,
      showMap: true,
      subscribedActivities
    })
  }

  handleSuccess () {
    const { location, router } = this.props
    const pagePath = location.pathname.replace('/connect', '')

    if (window.opener) {
      window.opener.postMessage('strava connected', '*')
      window.close()
    } else {
      window.postMessage('strava connected', '*')
      router.push(pagePath)
    }
  }

  render () {
    return (
      <Theme>
        <Status status='fetching' />
      </Theme>
    )
  }
}

const mapState = (state, props) => ({
  customSupporterPages: selectCustomSupporterPages(state, props),
  page: selectPage(state),
  user: selectUser(state)
})

export default connect(mapState)(StravaConnect)
